import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconSpeed = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 18,
	viewBox: "0 0 20 18",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18 10.5C18 12.7091 17.1046 14.7091 15.6569 16.1569L17.0711 17.5711C18.8807 15.7614 20 13.2614 20 10.5C20 4.97715 15.5228 0.5 10 0.5C4.47715 0.5 0 4.97715 0 10.5C0 13.2614 1.11929 15.7614 2.92893 17.5711L4.34315 16.1569C2.89543 14.7091 2 12.7091 2 10.5C2 6.08172 5.58172 2.5 10 2.5C14.4183 2.5 18 6.08172 18 10.5ZM13.293 5.79297L8.793 10.293L10.2072 11.7072L14.7072 7.20718L13.293 5.79297Z",
		fill: "#03314B"
	})
});
export default SvgIconSpeed;
